import api from "../utils/axios"

export const userApi = {
    // Invoice endpoints
    getAllInvoices: () => api.get('/documents/invoices-list/'),
    getInvoiceSummary: () => api.get('/documents/invoices/dashboard-summary/'),

    createManualInvoice: (data) => api.post('/documents/invoices/create-manual/', data),
    uploadDoc: (formData) => api.post('/documents/', formData),

    getInvoice: async (id) => {
        const res = await api.get(`/documents/invoices/${id}/`);
        return res.data; 
    },

    updateInvoice: async (businessId, invoiceId, data) => api.put(`/documents/invoices/${invoiceId}/update/business_id/${businessId}/`, data),

    deleteInvoice: async (id) => api.delete(`/documents/invoices/${id}/delete/`),

    exportInvoiceGST: async (businessId) => {
        const res = await api.get(
            `/documents/invoices/report/export/?business=${businessId}`,
            { responseType: 'blob' }
        );
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", "gst_report.json"); // filename
        document.body.appendChild(link);
        link.click();

        link.remove();
    },

    generatExcelFile: async (businessId) => {
        const res = await api.get(
            `/reports/generate/excel/?business=${businessId}`,
            { responseType: 'blob' }
        );
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", "invoices_excel.xlsx"); // filename
        document.body.appendChild(link);
        link.click();

        link.remove();
    },

    // Business related endpoints
    getAllBusiness: () => api.get('/users/business/'),
    getBusinessDetails: (businessId) => api.get(`/users/business/${businessId}/`),
    createNewBusiness: (data) => api.post('/users/business/create/', data),
    updateBusiness: (businessId, data) => api.put(`/users/business/${businessId}/update/`, data),
    deleteBusiness: (businessId) => api.delete(`/users/business/${businessId}/delete/`),

    validateRequestedDocument: (token) => api.get(`/client_requests/upload-document/${token}/details/`),
    uploadRequestedDocument: (token, source, formData) => api.post(`/client_requests/upload-document/${token}/submit/`, formData, { params: {source} }),
};
